import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../Context/LanguageContext';

const codes = { en: 'EN', ar: 'AR', fa: 'FA' };

const LanguageSwitcher = () => {
  const { language, changeLanguage, supportedLanguages } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languageNames = {
    en: 'English',
    ar: 'العربية',
    fa: 'فارسی',
  };

  const languageFlags = {
    en: '🇬🇧',
    ar: '🇸🇦',
    fa: '🇮🇷',
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLanguageChange = (lang) => {
    changeLanguage(lang);
    setIsOpen(false);
  };

  return (
    <div className="imigo-lang-switcher position-relative" ref={dropdownRef}>
      <button
        type="button"
        className={`imigo-lang-trigger ${isOpen ? 'imigo-lang-trigger--open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        aria-label="Change language"
      >
        <span className="imigo-lang-trigger__flag" aria-hidden>
          {languageFlags[language]}
        </span>
        <span className="imigo-lang-trigger__code">{codes[language]}</span>
        <svg
          className="imigo-lang-trigger__chevron"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          aria-hidden
        >
          <path
            d="M3 4.5L6 7.5L9 4.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="imigo-lang-dropdown" role="listbox">
          {supportedLanguages.map((lang) => (
            <button
              key={lang}
              type="button"
              role="option"
              aria-selected={language === lang}
              className={`imigo-lang-option ${language === lang ? 'imigo-lang-option--active' : ''}`}
              onClick={() => handleLanguageChange(lang)}
            >
              <span className="imigo-lang-option__flag">{languageFlags[lang]}</span>
              <span className="imigo-lang-option__label">{languageNames[lang]}</span>
              <span className="imigo-lang-option__code">{codes[lang]}</span>
              {language === lang && (
                <span className="imigo-lang-option__check" aria-hidden>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path
                      d="M11.5 3.5L5.5 9.5L2.5 6.5"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
